@if (!loadingPage()) {
  <common-ui-components-page-layout
    [stickyHeader]="true"
    [title]="' '"
    [hasBackAction]="false"
    [showBorder]="false"
    (onBackAction)="handleBackClick()"
    [leftTimer]="{ timeInSeconds: time(), timerType: 'mm:ss' }"
    (onFinishLeftTimer)="onFinish()"
    [ngClass]="{ blurred: isTimeout() }"
  >
    @switch (stepPage()) {
      @case (ForgotPasswordStepEnum.PHONE_NUMBER) {
        <forgot-password-applet-phone (nextStep)="stepPage.set($event)"></forgot-password-applet-phone>
      }
      @case (ForgotPasswordStepEnum.OTP) {
        <forgot-password-applet-otp (nextStep)="stepPage.set($event)"></forgot-password-applet-otp>
      }
      @case (ForgotPasswordStepEnum.PIN) {
        <forgot-password-applet-pin (nextStep)="stepPage.set($event)"></forgot-password-applet-pin>
      }
      @case (ForgotPasswordStepEnum.NID) {
        <forgot-password-applet-nid (nextStep)="stepPage.set($event)"></forgot-password-applet-nid>
      }
    }
  </common-ui-components-page-layout>
  @if (isTimeout()) {
    <div class="overlay p-plus">
      <ngx-status-result
        [title]="'مهلت شما به پایان رسیده است!'"
        [description]="
          'برای تکمیل فرآیند بازیابی، لطفاً مراحل را مجدداً از ابتدا و در مدت زمان مقرر انجام دهید. \n' +
          'در حال آماده‌سازی برای شروع مجدد ...'
        "
        [loading]="true"
      >
        <ng-container status-image>
          <div class="image-time-out"></div>
        </ng-container>
      </ngx-status-result>
    </div>
  }
} @else {
  <div class="d-flex w-100 h-100 align-items-center justify-content-center">
    <ngx-spinner size="lg"></ngx-spinner>
  </div>
}
